import React from "react";
import { compose } from 'redux';
import { Prompt, withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import queryString from "query-string";
import PropTypes from "prop-types";
import moment from 'moment';
import { /*Input, */NumericTextBox } from '@progress/kendo-react-inputs';
import {
    GridColumn as Column,
    GridToolbar
} from "@progress/kendo-react-grid";
//import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from '@progress/kendo-react-buttons';
import "@progress/kendo-theme-material/dist/all.css";
import EditPartExceptionPage from './EditPartExceptionPage';
import PartDemandPage from './PartDemandPage';
import SearchPartPage from './SearchPartPage';
import { isEmpty, getLocaleDateString/*, getExportFileName*/, convertDateToInteger } from "../helpers";
import { /*BooleanCell, */CurrencyCell, BlankCell, IconButtonCell } from "../components/utils/GridHelpers";
import GridContainer, { GridContainerToolbar, GridContainerToolbarOption } from '../components/GridContainer';
import CurrencyContainer from '../components/CurrencyContainer';
//import DropDownContainer from '../components/DropDownContainer';
import isPage from "../hoc/isPage";
import { AppContext } from '../context/AppContext';
import localize from "../hoc/localize";
//import arrowup from '../img/arrow-up.svg';
//import arrowdown from '../img/arrow-down.svg';
//import arrowblank from '../img/arrow-blank.svg';

//const centerDiv = {
//    width: '60%',
//    height: '200px',
//    margin: '0 auto',
//    backgroundcolor: '#FFA500'
//};
//const centerDiv = {
//    height: '200px',
//    margin: '0 auto'
//};

const NavigateAwayDialog = (props) => {

    //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
    let top = window.pageYOffset + (window.innerHeight - 200) / 2;
    return (
        <Dialog className="confirmation"
            width={400}
            style={{ height: 'auto', top: top, margin: '0 auto' }}
            onClose={props.handleCloseDialog}>

            {props.labels[0]}
            <DialogActionsBar>
                <Button className="cancel" onClick={props.handleCloseDialog}>{props.labels[1]}</Button>
                <Button className="yes" primary={true} onClick={(e) => {
                    props.handleSaveChanges();
                    props.handleConfirmNavigate();
                    props.handleCloseDialog();
                }}>{props.labels[2]}</Button>
                <Button className="no" onClick={(e) => {
                    props.handleConfirmNavigate();
                    props.handleCloseDialog();
                }}>{props.labels[3]}</Button>
            </DialogActionsBar>
        </Dialog>
    )
}
NavigateAwayDialog.propTypes = {
    handleConfirmNavigate: PropTypes.func,
    handleCloseDialog: PropTypes.func,
    handleSaveChanges: PropTypes.func,
    labels: PropTypes.array
}

class MyNumericTextBox extends NumericTextBox {
    constructor(props) {
        super(props);

        this.wheel = null;
    }
}

class OrderQuantityCell extends React.Component {

    element = null;

    handleOrderQuantityChange = (e) => {
        this.props.onChange({
            dataItem: this.props.dataItem,
            field: this.props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
            //value: e.target.value === null ? 0 : e.target.value
        });

        this.props.onChange({
            dataItem: this.props.dataItem,
            field: 'total',
            value: e.target.value * this.props.dataItem['cost']
        })
    }

    handleFocusOut = () => {
        if (isEmpty(this.element.value)) {
            //this.element.value = "0";
            this.props.onChange({
                dataItem: this.props.dataItem,
                field: this.props.field,
                value: 0
            });
        }
    }

    componentWillUnmount() {
        this.element.removeEventListener('focusout', this.handleFocusOut);
    }

    componentDidMount() {
        this.element.addEventListener('focusout', this.handleFocusOut);
    }

    //zeroOutOrderQuantity = (e) => {
    //    this.props.onChange({
    //        dataItem: this.props.dataItem,
    //        field: 'orderQuantity',
    //        value: 0
    //    })
    //    this.props.onChange({
    //        dataItem: this.props.dataItem,
    //        field: 'total',
    //        value: 0
    //    })
    //}
    //<span onClick={this.zeroOutOrderQuantity} style={{'cursor': 'pointer'}}>X</span>

    //disabled={this.props.dataItem['neverOrder']}

    render() {

        let className = 'numeric orderqty';
        if (this.props.dataItem['updated'] > 0)
            className += ' updated';
        if (this.props.dataItem['orderQuantity'] > this.props.dataItem['suggestedQuantity'])
            className += ' greater';
        else if (this.props.dataItem['orderQuantity'] < this.props.dataItem['suggestedQuantity'])
            className += ' less';

        return (
            <td className={className}>

                <MyNumericTextBox
                    width={"100%"}
                    min={0}
                    spinners={false}
                    name="orderQuantity"
                    onChange={this.handleOrderQuantityChange}
                    ref={(numericTextBox) => this.element = numericTextBox ? numericTextBox.element : null}
                    value={this.props.dataItem['orderQuantity']} />
            </td>
        )
    }
}

//class DescWithQtiesCell extends React.Component {
//    render() {
//        return (
//            <td>
//                {this.props.dataItem['description']}
//                <div className="quantities">Available: <span>{this.props.dataItem['qtyAvailable']}</span> - On Order: <span>{this.props.dataItem['qtyOnOrder']}</span> - Sold: <span>{this.props.dataItem['qtySold']}</span></div>
//            </td>
//        )
//    }
//}

class DescWithPackageInfoCell extends React.Component {
    render() {
        return (
            <td>
                {this.props.dataItem['description']}
                {this.props.dataItem['package'] && (<div className="quantities"><span>{this.props.dataItem['packageCount']}</span> {this.props.returnLocalizedString("m0254")}</div>)}
            </td>
        );
    }
}
const DescWithPackageInfoCellLocalized = localize(DescWithPackageInfoCell)

class SuggestedQtyWithPackageInfoCell extends React.Component {
    render() {
        //let src;
        //let alt;
        //switch (this.props.dataItem['suggestedQtyEnforcement']) {
        //    case 0:
        //        src = arrowblank;
        //        alt = ' ';
        //        break;
        //    case 1:
        //        src = arrowup;
        //        alt = '^';
        //        break;
        //    case 2:
        //        src = arrowdown;
        //        alt = 'v';
        //        break;
        //    default:
        //        break;
        //}

        let icon;
        switch (this.props.dataItem['suggestedQtyEnforcement']) {
            case 0:
                icon = <span className="k-icon" />
                break;
            case 1:
                icon = <span className="k-icon k-i-sort-asc-sm" />;
                break;
            case 2:
                icon = <span className="k-icon k-i-sort-desc-sm" />;
                break;
            default:
                break;
        }

        let className = 'numeric suggestedqty';
        if (this.props.dataItem['suggestedQuantity'] === 0)
            className += ' zerosuggested';
        //<img style={{ width: 5, height: 16, paddingLeft: 4 }} src={src} alt={alt} />
        return (
            <td className={className}>
                <div>
                    <span className="suggestedqty">{this.props.dataItem['suggestedQuantity'].toLocaleString()}</span>
                    {this.props.dataItem['package'] ? <span className="pkg">&nbsp;{this.props.returnLocalizedString("m0316")}</span> : <span className="pkg"></span>}
                    {icon}
                </div>
            </td>
        );
    }
}
const SuggestedQtyWithPackageInfoCellLocalized = localize(SuggestedQtyWithPackageInfoCell)

//class PackageCountCell extends React.Component {
//    render() {
//        return (
//            <td className="numeric">
//                {this.props.dataItem['packageCount'] ? this.props.dataItem['packageCount'] : "-"}
//            </td>
//        )
//    }
//}

function columnsAllowEdit(props) {
    return [
        { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0440"), minWidnt: 20, editable: false },
        { field: "description", key: "description", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false, cell: DescWithPackageInfoCellLocalized },
        { field: "qtySold", key: "qtySold", title: props.returnLocalizedString("m0261"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "qtyOnOrder", key: "qtyOnOrder", title: props.returnLocalizedString("m0441"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "qtyAvailable", key: "qtyAvailable", title: props.returnLocalizedString("m0260"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "suggestedQuantity", key: "suggestedQuantity", title: props.returnLocalizedString("m0442"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: SuggestedQtyWithPackageInfoCellLocalized },
        { field: "orderQuantity", key: "orderQuantity", title: props.returnLocalizedString("m0315"), minWidnt: 20, editable: true, headerClassName: "numeric", className: "numeric", cell: OrderQuantityCell },
        { field: "cost", key: "cost", title: props.returnLocalizedString("m0318"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "total", key: "total", title: props.returnLocalizedString("m0267"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { key: "button1", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: IconButtonCell },
        { key: "button2", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: IconButtonCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }]
};

function columnsNotAllowEdit(props) {
    return [
        { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0440"), minWidnt: 20, editable: false },
        { field: "description", key: "description", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false, cell: DescWithPackageInfoCellLocalized },
        { field: "qtySold", key: "qtySold", title: props.returnLocalizedString("m0261"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "qtyOnOrder", key: "qtyOnOrder", title: props.returnLocalizedString("m0441"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "qtyAvailable", key: "qtyAvailable", title: props.returnLocalizedString("m0260"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "suggestedQuantity", key: "suggestedQuantity", title: props.returnLocalizedString("m0442"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: SuggestedQtyWithPackageInfoCellLocalized },
        { field: "cost", key: "cost", title: props.returnLocalizedString("m0318"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "total", key: "total", title: props.returnLocalizedString("m0267"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { key: "button", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: IconButtonCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }]
};

const ADJUST_PADDING = 0;
const COLUMN_MIN = 4;

class VendorSuggestedOrders extends React.Component {
    _export;
    vendorName;
    orgName;
    orderType;
    selectedOrgID;

    minGridWidth = 0;

    // the first new part number
    newPart;

    static propTypes = {
        orgVendorID: PropTypes.string.isRequired,
        selectedOrgID: PropTypes.number,
        orderType: PropTypes.string

    };

    constructor(props) {
        super(props);

        let vals = queryString.parse(window.location.search);
        this.vendorName = "vendor";
        this.orderType = "0";

        if (vals) {
            if (!isEmpty(vals["vendorName"])) {
                this.vendorName = vals["vendorName"];
            }
            if (!isEmpty(vals["selectedOrgID"])) {
                this.selectedOrgID = vals["selectedOrgID"]
            }
            if (!isEmpty(vals["orgName"])) {
                this.orgName = vals["orgName"];
            }

        }

        this.state = {
            suggestedOrders: [],
            soDate: null, // date when the suggested orders were computed
            suggestedPOID: null, // the ID of the suggested PO
            unsaved: false, // indicates that changes have been made to the suggested order that haven't been saved yet
            nextLocation: '', // URL that the user attempted to navigate to before saving his changes
            performRedirect: false, // when set to true, indicates that user wants to navigate away without saving changes

            orgID: null, // the selected orgID, or the user orgID (for dealer user)
            showDialog: false,
            showDetailsDialog: false,
            showSearchPartDialog: false,
            selectedPart: null,

            //columns: [],
            setMinWidth: false,
            gridCurrent: 0
        };
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log('componentDidUpdate');

        if (this.newPart !== undefined) {
            // find the table row of first new part
            const rows = document.querySelectorAll('.k-master-row');
            const idx = [...rows].findIndex(r => r.cells[0].innerText === this.newPart);
            if (idx >= 0) {
                var bounding = rows[idx].getBoundingClientRect();

                if (bounding.top < 0 || bounding.bottom > (window.innerHeight || document.documentElement.clientHeight)) {
                    rows[idx].scrollIntoView();
                }
            }

            this.newPart = undefined;
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentDidMount() {

        //console.log('componentDidMount')
        //console.log('this.gridcontainer.props.children', this.gridcontainer.props.children)
        // determine if necessary to pass in selectedOrgID
        const orgType = this.context.state.orgType;
        //let apiUrl = `/api/portal/vendor/${this.props.orgVendorID}/GetSuggestedPurchaseOrders`;
        let apiUrl = `/api/portal/vendor/GetSuggestedPurchaseOrders`;

        let params = {}
        params.orgVendorID = decodeURIComponent(this.props.orgVendorID);

        // if dealergroup or higher, then we need to filter results by selectedOrgID
        if (orgType !== "dealer") {
            params.selectedOrgID = this.selectedOrgID
        }


        this.orderType = this.props.orderType;
        params.orderType = this.props.orderType

        apiUrl += ('?' + queryString.stringify(params))


        this.props.getData(`/api/portal/adjustmentReason/GetList?uiLanguage=${this.props.uiLanguage}`).then((adjustmentReasons) => {
            this.setState({
                adjustmentReasons: [{ adjustmentReasonID: null, adjustmentReason: "" }].concat(adjustmentReasons.data),
            })
        })

        const orgID = (orgType !== "dealer" ? this.selectedOrgID : this.context.state.orgID);
        this.props.getData(`/api/portal/season/${orgID}`).then((seasons) => {
            this.setState({
                seasons: [{ seasonID: null, seasonName: "" }].concat(seasons.data),
            })
        });

        this.props.getData(apiUrl).then((suggestedOrders) => {
            if (isEmpty(suggestedOrders) || isEmpty(suggestedOrders.data)) {
                this.props.infoAlert("m0443");

            } else {
                this.grid = document.querySelector('.k-grid');
                window.addEventListener('resize', this.handleResize);

                let columns;
                if (this.context.state.allowEditSuggestedOrders)
                    columns = columnsAllowEdit(this.props);
                else
                    columns = columnsNotAllowEdit(this.props);

                this.minGridWidth = 650;
                columns.map(item => this.minGridWidth += item.minWidnt);

                // try to get the date of the purchase order
                this.setState({
                    suggestedOrders: suggestedOrders.data.map((lineItem, index) => Object.assign({
                        inEdit: true,   // the Boolean field which indicates the edit state of the item
                        updated: 0,     // the Integer field which indicates whether the item have be updated or inserted (0: unchanged, 1: updated, 2: inserted)
                        originalOrderQuantity: lineItem.orderQuantity,
                        index,
                        //descWithQties: lineItem.description + "<div class=\"quantities\">Available: <strong>" + lineItem.qtyAvailable + "</strong> - On Order: <strong>" + lineItem.qtyOnOrder + "</strong> - Sold: <strong>" + lineItem.qtySold + "</strong></div>"
                        //descWithQties: { description: lineItem.description, qtyAvailable: lineItem.qtyAvailable, qtyOnOrder: lineItem.qtyOnOrder, qtySold: lineItem.qtySold }
                    }, lineItem)),
                    soDate: suggestedOrders.data[0].soDate,
                    suggestedPOID: suggestedOrders.data[0].suggestedPOID,
                    orgID: orgID,

                    //columns: columns,
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: this.grid.offsetWidth < this.minGridWidth
                });
                this.handleResize();
            }
        })
    }

    handleResize = () => {

        if (this.grid) {
            if (this.grid.offsetWidth < this.minGridWidth && !this.state.setMinWidth) {
                this.setState({
                    setMinWidth: true
                });
            } else if (this.grid.offsetWidth > this.minGridWidth) {
                this.setState({
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: false
                });
            }
        }

    }

    setWidth = (minWidth, percentage) => {
        //console.log("state.gridCurrent: ", this.state.gridCurrent);
        //if (this.grid)
        //    console.log("grid.offsetWidth: ", this.grid.offsetWidth);
        //let columnsLength;
        //if (this.context.state.allowEditSuggestedOrders)
        //    columnsLength = columnsAllowEdz.length;
        //else
        //    columnsLength = columnsNotAllowEdit.length;
        //let width = this.state.setMinWidth ? minWidth :
        //    minWidth + (this.state.gridCurrent - this.minGridWidth) / columnsLength;
        let width = this.state.setMinWidth ? minWidth :
            Math.round(this.state.gridCurrent / 100 * percentage);
        width = width < COLUMN_MIN ? width : width - ADJUST_PADDING;
        //console.log("width: ", width);
        return width;
    }

    // create the filename for the csv and excel exports
    getFileName = (fileExtension) => {

        // vendor name (all spaces replaced by dashes) + "yyyy-mm-dd.csv"   
        const dateStamp = moment(this.state.soDate, "YYYYMMDD").format("YYYY-MM-DD");

        // dealer name
        //let fileName = `${this.vendorName.replace(/\s/g, "-")}-${dateStamp}.${fileExtension}`;
        let fileName = `${this.vendorName.replace(/\s/g, "-")}`;
        switch (parseInt(this.orderType, 10)) {
            case 1:
                fileName = `${fileName}-GM-${dateStamp}.${fileExtension}`;
                break;
            case 2:
                fileName = `${fileName}-P&A-${dateStamp}.${fileExtension}`;
                break;
            default:
                fileName = `${fileName}-${dateStamp}.${fileExtension}`;
                break;
        }

        if (!isEmpty(this.orgName)) {
            fileName = `${this.orgName.replace(/\s/g, '-')}-${fileName}`;
        }

        return fileName;

    }

    // get the data to export in the csv download.
    // only 3 fields: part number, quantity, and package (a bool field)
    // no headers.
    getCsvData = () => {
        let csvData = [];

        const { allowEditSuggestedOrders } = this.context.state;

        this.state.suggestedOrders.forEach(order => {
            // if allowing user to edit suggested orders, then ....
            //      export order quantity (if defined, otherwise export suggested quantity)
            // else
            //      export suggested quantity only
            let quantity = (allowEditSuggestedOrders ? (isEmpty(order.orderQuantity) ? 0 : order.orderQuantity) : order.suggestedQuantity);
            if (quantity > 0) {
                csvData.push([
                    order.partNumber,
                    quantity
                ]);
            }

        });
        return csvData;
    }

    rowRender = (row, props) => {
        if (props.dataItem['updated'] === 2) {
            //const red = { backgroundColor: "rgb(243, 23, 0, 0.12)" };
            const red = { backgroundColor: "rgb(254, 227, 224)" };
            const trProps = { style: red };
            const newRow = React.cloneElement(row, { ...trProps }, row.props.children);
            //console.log('rowRender')
            return newRow;
        }
        return row;
    }

    handleItemChange = (e) => {
        //console.log('handleItemChange')
        e.dataItem[e.field] = e.value;
        e.dataItem['updated'] = e.dataItem['updated'] === 0 ? 1 : e.dataItem['updated'];

        const index = e.dataItem['index'];

        this.setState({
            suggestedOrders: Object.assign([], this.state.suggestedOrders, { [index]: e.dataItem }),
            unsaved: true
        });
    }

    handleAdjustmentReasonChange = (dataItem, value) => {
        //debugger;
        dataItem['adjReason'] = value;
        dataItem['updated'] = dataItem['updated'] === 0 ? 1 : dataItem['updated'];

        this.setState({
            suggestedOrders: [...this.state.suggestedOrders],
            unsaved: true
        });
    }

    handleNeverOrderChange = (dataItem) => {
        // value = true, means that the checkbox is checked
        //debugger;
        //console.log('neverorder', value)

        const neverOrder = !dataItem['neverOrder'];

        // flip the order around
        dataItem['neverOrder'] = neverOrder;
        if (neverOrder) {
            dataItem['orderQuantity'] = 0;
            dataItem['total'] = 0;
        }
        dataItem['updated'] = dataItem['updated'] === 0 ? 1 : dataItem['updated'];

        this.setState({
            suggestedOrders: [...this.state.suggestedOrders],
            unsaved: true
        });
    }

    // validate the user's inputs
    validateInputValues = () => {

        let error = "";

        !isEmpty(this.state.suggestedOrders) && this.state.suggestedOrders.forEach(suggestedOrder => {
            if ((suggestedOrder.neverOrder !== null && suggestedOrder.neverOrder)
                && (suggestedOrder.adjReason === null || suggestedOrder.adjReason.adjustmentReasonID === null)) {
                error = suggestedOrder.partNumber;
            }
        });

        if (!isEmpty(error)) {
            this.props.errorAlert("m0272", "", error);
            return false;
        }
        return true;
    }

    handleSearchParts = (e, props) => {

        // bring up the dialog
        this.setState({
            showSearchPartDialog: true
        })
    }

    handleCloseSearchPartModal = (elmnt, payload) => {

        if (payload) {
            let suggestedOrders = this.state.suggestedOrders;

            payload.forEach(p => {
                if (suggestedOrders.findIndex(i => i.partNumber === p.partNumber) === -1) {
                    if (this.newPart === undefined)
                        this.newPart = p.partNumber;

                    suggestedOrders.push({
                        partNumber: p.partNumber,
                        description: p.description,
                        package: p.package,
                        packageCount: p.packageUnit,
                        cost: p.cost,
                        total: 0,
                        soDate: this.state.soDate,
                        suggestedPOID: this.state.suggestedPOID,
                        suggestedPOItemID: null,
                        suggestedQuantity: 0,
                        orderQuantity: 0,
                        neverOrder: false/*p.neverOrder*/,
                        stockingMAX: null/*p.stockingMAX*/,
                        qtyAvailable: p.quantityAvailable,
                        qtyOnOrder: p.qtyOnOrder,
                        qtySold: p.quantitySold,
                        partExceptionsExist: p.partExceptionsExist,
                        suggestedQtyEnforcement: 0,
                        adjReason: null/*p.adjReason*/,
                        inEdit: true,
                        updated: 2,
                        originalOrderQuantity: 0,
                        index: suggestedOrders.length
                    });
                }
            });

            this.setState({
                suggestedOrders: suggestedOrders,
                unsaved: true
            });
        }

        this.setState({
            showSearchPartDialog: false
        });
    }

    handleSaveChanges = () => {
        //console.log(`saving the following suggested orders...`, this.state.suggestedOrders)

        //let updatedOrders = this.state.suggestedOrders.filter(o => o.updated > 0 && o.orderQuantity !== o.originalOrderQuantity);
        let updatedOrders = this.state.suggestedOrders.filter(o => o.updated > 0);
        if (updatedOrders.length <= 0) {
            this.props.warningAlert("m0274")
            return;
        }

        // validate the inputs
        //if (!this.validateInputValues()) {
        //    return;
        //}

        const extractedData = updatedOrders.map((order, index) => {

            //let adjustmentReasonID = null
            //// null out adjustmentReasonID if orderQuantity has been blanked out, OR if orderQuantity = suggestedQuantity
            //if ((order.orderQuantity !== null && order.orderQuantity.toString().length > 0) && (order.orderQuantity !== order.suggestedQuantity)) {
            //    if (order.adjReason)
            //        adjustmentReasonID = order.adjReason.adjustmentReasonID
            //}
            return ({
                suggestedPOID: order.suggestedPOID,
                suggestedPOItemID: order.suggestedPOItemID,
                orderQuantity: (isEmpty(order.orderQuantity) ? 0 : order.orderQuantity),
                orgID: this.state.orgID,
                orgVendorID: this.props.orgVendorID,
                partNumber: order.partNumber
            })
        })

        this.props.postData(`/api/portal/vendor/UpdateSuggestedPurchaseOrders_New`, extractedData).then(response => {
            this.props.successAlert("m0447", "", extractedData.length);

            // lower this flag, since a save has just been performed
            this.setState({
                unsaved: false,
                suggestedOrders: this.state.suggestedOrders.map(order => {
                    //// if order quantity is same as suggested quantity, OR order quantity was made blank, then let's remove the adjustment reason
                    //if (order.orderQuantity === null || (order.orderQuantity === order.suggestedQuantity)) {
                    //    order.adjReason = {
                    //        adjustmentReason: null,
                    //        adjustmentReasonID: null
                    //    };
                    //}
                    if (isEmpty(order.orderQuantity)) {
                        order.orderQuantity = 0;
                    }
                    if (order.originalOrderQuantity !== order.orderQuantity) {
                        order.originalOrderQuantity = order.orderQuantity;
                    }
                    order.updated = 0;
                    return order;
                })
            })
        }).catch(error => {
            this.props.alert("error", "Error!", error.message)
        })
    }

    // show dialog to confirm whether user wants to navigate away despite having unsaved changes
    showNavigateAwayDialog = (location) => {
        //debugger;
        this.setState({
            showNavigateAwayDialog: true,
            nextLocation: location
        })
    }

    // navigate away
    handleConfirmNavigate = () => {
        this.setState({
            performRedirect: true
        })
    }

    // close the "are you sure you want to leave without saving changes" dialog
    handleCloseDialog = () => {
        this.setState({
            showNavigateAwayDialog: false
        })
    }

    handleCloseModal = (elmnt, payload) => {

        if (payload) {
            if (payload[0]) {
                //console.log(payload[0])
                const suggestedOrders = this.state.suggestedOrders;
                let suggestedOrder = suggestedOrders.find(part => part.partNumber === payload[0].partNumber);
                //suggestedOrder.partExceptionsExist = (payload[0].neverOrder || payload[0].stockingMIN !== null || payload[0].stockingMAX !== null);
                if (!payload[0].neverOrder && payload[0].stockingMIN === null && payload[0].stockingMAX === null && payload[0].seasonID === null)
                    suggestedOrder.partExceptionsExist = 0;
                else {
                    suggestedOrder.partExceptionsExist = 2;

                    const today = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).format("YYYYMMDD");
                    if (payload[0].neverOrder)
                        suggestedOrder.partExceptionsExist = 1;
                    else if (payload[0].stockingMIN !== null) {
                        if (payload[0].minExpiryDate === null)
                            suggestedOrder.partExceptionsExist = 1;
                        else if (payload[0].minExpiryDate > today)
                            suggestedOrder.partExceptionsExist = 1;
                    }
                    else if (payload[0].stockingMAX !== null) {
                        if (payload[0].maxExpiryDate === null)
                            suggestedOrder.partExceptionsExist = 1;
                        else if (payload[0].maxExpiryDate > today)
                            suggestedOrder.partExceptionsExist = 1;
                    }
                    else if (payload[0].seasonID !== null) {
                        suggestedOrder.partExceptionsExist = 1;
                    }

                }
                this.setState({
                    showDialog: false,
                    selectedPart: null,
                    suggestedOrders: suggestedOrders
                });
            }
        }
        else
            this.setState({
                showDialog: false,
                selectedPart: null
            });
    }

    handleEditClick = (e, props) => {

        // bring up the dialog
        this.setState({
            showDialog: true,
            selectedPart: props.dataItem
        })
    }

    handleDetailsClick = (e, props) => {

        // bring up the dialog
        this.setState({
            showDetailsDialog: true,
            selectedPart: props.dataItem
        })
    }

    handleCloseDetailsModal = (e, props) => {

        this.setState({
            showDetailsDialog: false,
            selectedPart: null
        });
    }

    setPercentage = (percentage) => {
        return Math.round(this.gridWidth / 100) * percentage;
    }
    //width = { this.setPercentage(10) }
    //width = { this.setWidth(column.minWidnt) }


    render() {
        //console.log('render')
        let toolBarContent = "";
        const localeDateString = getLocaleDateString().toUpperCase();

        // create a summary of the data, which will include:
        // - number of line items in the suggested order
        // - total cost
        // - date when the suggested order was computed
        const soDate = (this.state.soDate ? moment(this.state.soDate, "YYYYMMDD").format(localeDateString) : '');

        if (
            this.state.suggestedOrders &&
            this.state.suggestedOrders.length > 0
        ) {

            let totalUnits = 0;
            this.state.suggestedOrders.forEach((order) => {
                totalUnits += ((isEmpty(order.orderQuantity) ? 0 : order.orderQuantity) * (order.package ? order.packageCount : 1))
            });

            const today = new Date();
            ////Even if it�s day 1 of the month, JavaScript is logical enough and it will point to the last day of the previous month.
            //const yesterday = new Date(today.setDate(today.getDate() - 1))
            const intToday = convertDateToInteger(today);
            let soDateClassName = 'info';
            if (this.state.soDate < intToday)
                soDateClassName += ' old';

            toolBarContent = (
                <span className="grid-totals">
                    <span className="info">
                        {this.props.returnLocalizedString("m0448")}&nbsp;<span>{this.state.suggestedOrders.length}</span>
                    </span>
                    <span className="info">
                        {this.props.returnLocalizedString("m0449")}&nbsp;<span>{totalUnits}</span>
                    </span>
                    <span className="info">
                        {this.props.returnLocalizedString("m0450")}&nbsp;<span><CurrencyContainer quantity={this.state.suggestedOrders.reduce((a, b) => ({
                            total: a.total + b.total
                        })).total} /></span>
                    </span>
                    <span className={soDateClassName}>
                        {
                            soDate &&
                            (
                                <React.Fragment>
                                    {this.props.returnLocalizedString("m0451")}&nbsp;<span>{soDate}</span>
                                </React.Fragment>
                            )
                        }
                    </span>
                </span>
            );
        }

        // get filenames of exports
        const csvFileName = this.getFileName("csv");
        const xlsxFileName = this.getFileName("xlsx");

        // get the header
        let header;
        if (this.context.state.orgType === "dealer") {
            header = (<React.Fragment>{this.props.returnLocalizedString("m0452")} <strong>{this.vendorName}</strong>.</React.Fragment>);
        } else {
            header = (<React.Fragment>
                <span className="padding-right-20">
                    {this.props.returnLocalizedString("m0433")} <strong>{this.orgName}</strong>
                </span>
                <br />
                {this.props.returnLocalizedString("m0452")} <strong>{this.vendorName}</strong>.
            </React.Fragment>);
        }

        let saveButton = <React.Fragment />;
        if (this.context.state.allowEditSuggestedOrders) {
            saveButton = (
                <GridContainerToolbar>
                    <GridContainerToolbarOption type="add-part" tooltip="m0453" handleClick={this.handleSearchParts} />
                    <GridContainerToolbarOption type="save" tooltip="m0252" primary={true} handleClick={this.handleSaveChanges} />
                </GridContainerToolbar>
            )
        }

        if (this.state.performRedirect && (!isEmpty(this.state.nextLocation))) {

            return <Redirect to={this.state.nextLocation} />
        }

        //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
        let top = window.pageYOffset + (window.innerHeight - 200) / 2;
        let searchPartTop = window.pageYOffset + window.innerHeight / 2;

        //const qtyAvailableColumn = (
        //    <Column
        //        field="qtyAvailable"
        //        className="numeric"
        //        width="97px"
        //        editable={false}
        //    />
        //);
        //const qtyOnOrderColumn = (
        //    <Column
        //        field="qtyOnOrder"
        //        headerClassName="numeric"
        //        width="97px"
        //        editable={false}
        //    />
        //);
        //const qtySoldColumn = (
        //    <Column
        //        field="qtySold"
        //        className="numeric"
        //        width="97px"
        //        editable={false}
        //    />
        //);
        //const childColumns = { qtyAvailableColumn, qtyOnOrderColumn, qtySoldColumn};

        //<Column
        //    field="package"
        //    title= {this.props.returnLocalizedString("m0316")}
        //    width="43px"
        //    headerClassName="boolean"
        //    className="boolean"
        //    cell={props => (
        //        <BooleanCell mode="checkbox" {...props} />
        //    )}
        //    editable={false}
        ///>
        //<Column
        //    field="packageCount"
        //    className="numeric"
        //    headerClassName="numeric"
        //    title={this.props.returnLocalizedString("m0317")}
        //    width="78px"
        //    editable={false}
        //    cell={PackageCountCell}
        ///>
        //{
        //    this.context.state.allowEditSuggestedOrders ?
        //        <Column
        //            key="neverOrder"
        //            field="neverOrder"
        //            title={this.props.returnLocalizedString("m0267")}
        //            headerClassName="boolean"
        //            className="boolean"
        //            width="90px"
        //            cell={(props) => (
        //                <BooleanCell mode="checkbox" handleChange={(e) => { this.handleNeverOrderChange(props.dataItem) }} editable={true} {...props} />
        //            )}
        //        />
        //        : <React.Fragment />
        //}
        //{
        //    this.context.state.allowEditSuggestedOrders ? (
        //        <Column
        //            field="adjReason.adjustmentReason"
        //            title={this.props.returnLocalizedString("m0153")}
        //            width="160px"
        //            cell={props => {

        //                return (
        //                    <td>

        //                        <DropDownList
        //                            value={props.dataItem.adjReason}
        //                            data={this.state.adjustmentReasons}
        //                            textField="adjustmentReason"
        //                            dataItemKey="adjustmentReasonID"
        //                            onChange={(e) => {
        //                                this.handleAdjustmentReasonChange(props.dataItem, e.target.value)
        //                            }}
        //                        />
        //                    </td>
        //                )
        //            }
        //            }
        //        />
        //    ) : <React.Fragment />
        //}

        // 448px is the perfect width with the current css styles
        let perfectPartExceptionDialogWidth = 448;
        let partExceptionDialogWidth = `${perfectPartExceptionDialogWidth}px`;
        if (this.state.showDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectPartExceptionDialogWidth)
                    partExceptionDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        // 646px is the perfect width with the current css styles
        let perfectPartDemandDialogWidth = 646;
        let partDemandDialogWidth = `${perfectPartDemandDialogWidth}px`;
        if (this.state.showDetailsDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectPartDemandDialogWidth)
                    partDemandDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        // 772px is the perfect width with the current css styles
        let perfectSearchPartDialogWidth = 772;
        let searchPartDialogWidth = `${perfectSearchPartDialogWidth}px`;
        if (this.state.showSearchPartDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectSearchPartDialogWidth)
                    searchPartDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        //!DBTRANS! @m0101@ Cancel !DEVNOTE! Option label
        //!DBTRANS! @m0251@ Would you like to save your changes? !DEVNOTE! Option label
        //!DBTRANS! @m0252@ Save !DEVNOTE! Option label
        //!DBTRANS! @m0253@ Exit without saving !DEVNOTE! Option label
        //!DBTRANS! @m0254@ parts/pkg !DEVNOTE! Attribute label
        //!DBTRANS! @m0316@ Pkg !DEVNOTE! Column label
        //!DBTRANS! @m0258@ Description !DEVNOTE! Input field label
        //!DBTRANS! @m0261@ Sold !DEVNOTE! Input field label
        //!DBTRANS! @m0260@ Avail !DEVNOTE! Input field label
        //!DBTRANS! @m0315@ Order Qty !DEVNOTE! Column label
        //!DBTRANS! @m0318@ Cost !DEVNOTE! Column label
        //!DBTRANS! @m0267@ Total !DEVNOTE! Time label
        //!DBTRANS! @m0272@ You must select an adjustment reason for part number %var1%! !DEVNOTE! Action status reason
        //!DBTRANS! @m0274@ No record is modified. !DEVNOTE! Action status reason
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
        //!DBTRANS! @m0433@ Dealer: !DEVNOTE! 
        //!DBTRANS! @m0252@ Save !DEVNOTE! Option label
        //!DBTRANS! @m0316@ Pkg !DEVNOTE! Column label
        //!DBTRANS! @m0317@ Units/Pkg !DEVNOTE! Column label
        //!DBTRANS! @m0267@ Never order !DEVNOTE! Input field label
        //!DBTRANS! @m0153@ Adjustment reason !DEVNOTE! Field label
        //!DBTRANS! @m0279@ Settings !DEVNOTE! Option label
        //!DBTRANS! @m0281@ Demand !DEVNOTE! Option label
        //!DBTRANS! @m0440@ Part # !DEVNOTE! 
        //!DBTRANS! @m0441@ On order !DEVNOTE! 
        //!DBTRANS! @m0442@ Suggested !DEVNOTE! 
        //!DBTRANS! @m0443@ There were no suggested orders to show for this vendor. !DEVNOTE! 
        //!DBTRANS! @m0444@ Available:  !DEVNOTE! 
        //!DBTRANS! @m0445@  - On Order:  !DEVNOTE! 
        //!DBTRANS! @m0446@  - Sold:  !DEVNOTE! 
        //!DBTRANS! @m0447@ The %var1% suggested order part(s) have been successfully updated. !DEVNOTE! 
        //!DBTRANS! @m0448@ Line Items: !DEVNOTE! 
        //!DBTRANS! @m0449@ Total Units: !DEVNOTE! 
        //!DBTRANS! @m0450@ Total Value: !DEVNOTE! 
        //!DBTRANS! @m0451@ Date Generated: !DEVNOTE! 
        //!DBTRANS! @m0452@ This is the suggested purchase order for !DEVNOTE! 
        //!DBTRANS! @m0453@ Add Part !DEVNOTE! 

        return (
            <div className="grid-col m-col-12 no-left-pad">
                <p >
                    {header}
                </p>

                {this.state.showNavigateAwayDialog && (
                    <NavigateAwayDialog
                        handleConfirmNavigate={this.handleConfirmNavigate}
                        handleCloseDialog={this.handleCloseDialog}
                        handleSaveChanges={this.handleSaveChanges}
                        labels={[this.props.returnLocalizedString('m0251'), this.props.returnLocalizedString('m0101'), this.props.returnLocalizedString('m0252'), this.props.returnLocalizedString('m0253')]}
                    />
                )}

                <Prompt
                    when={this.state.unsaved}
                    message={location => {
                        this.showNavigateAwayDialog(`${location.pathname}${location.search}`);
                        return false
                    }}
                />
                <GridToolbar >{toolBarContent}</GridToolbar>
                <GridContainer
                    data={this.state.suggestedOrders}
                    sortColumn="partNumber"
                    excelFilename={xlsxFileName}
                    csvFilename={csvFileName}
                    csvData={this.getCsvData()}
                    referenceID={this.state.suggestedPOID}
                    hasShowExcludedParts={this.context.state.allowEditSuggestedOrders}
                    editField="inEdit"
                    rowRender={this.rowRender}
                    onItemChange={this.handleItemChange}
                    hasSummaryLine={true}
                    pageable={true
                    }
                    pageSizes = {[25, 50, 100, 150]}
                    pageSize = {50}
                >

                    {saveButton}

                    <Column
                        field="partNumber"
                        title={this.props.returnLocalizedString("m0440")}
                        width={this.setWidth(80, 8)}
                        editable={false}
                    />
                    <Column
                        field="description"
                        title={this.props.returnLocalizedString("m0258")}
                        width={this.setWidth(100, 26)}
                        editable={false}
                        cell={DescWithPackageInfoCellLocalized}
                    />
                    <Column
                        field="qtySold"
                        headerClassName="numeric"
                        className="numeric"
                        title={this.props.returnLocalizedString("m0261")}
                        width={this.setWidth(50, 6)}
                        editable={false}
                    />
                    <Column
                        field="qtyOnOrder"
                        headerClassName="numeric"
                        className="numeric"
                        title={this.props.returnLocalizedString("m0441")}
                        width={this.setWidth(50, 6)}
                        editable={false}
                    />
                    <Column
                        field="qtyAvailable"
                        headerClassName="numeric"
                        className="numeric"
                        title={this.props.returnLocalizedString("m0260")}
                        width={this.setWidth(50, 6)}
                        editable={false}
                    />
                    <Column
                        field="suggestedQuantity"
                        headerClassName="numeric suggestedqtynopkg"
                        className="numeric"
                        title={this.props.returnLocalizedString("m0442")}
                        width={this.setWidth(60, 11)}
                        editable={false}
                        cell={SuggestedQtyWithPackageInfoCellLocalized}
                    />
                    {
                        this.context.state.allowEditSuggestedOrders ?
                            <Column
                                key="orderQuantity"
                                field="orderQuantity"
                                title={this.props.returnLocalizedString("m0315")}
                                headerClassName="numeric"
                                className="numeric"
                                width={this.setWidth(60, 11)}
                                cell={OrderQuantityCell}

                            /> : <React.Fragment />
                    }
                    <Column
                        field="cost"
                        title={this.props.returnLocalizedString("m0318")}
                        headerClassName="numeric"
                        className="numeric"
                        cell={props => (
                            <CurrencyCell {...props} />
                        )}
                        width={this.setWidth(60, 9)}
                        editable={false}
                    />
                    <Column
                        field="total"
                        title={this.props.returnLocalizedString("m0593")}
                        headerClassName="numeric"
                        className="numeric"
                        cell={props => (
                            <CurrencyCell {...props} />
                        )}
                        width={this.setWidth(60, 9)}
                        editable={false}
                    />
                    {
                        this.context.state.allowEditSuggestedOrders ?
                            <Column
                                filterable={false}
                                resizable={false}
                                sortable={false}
                                reorderable={false}
                                editable={false}
                                width={this.setWidth(40, 3)}
                                cell={(props) => (
                                    <IconButtonCell handleClick={(e) => { this.handleEditClick(e, props) }} icon="Edit" title={this.props.returnLocalizedString("m0279")} {...props} />
                                )}
                            /> : <React.Fragment />
                    }
                    <Column
                        filterable={false}
                        resizable={false}
                        sortable={false}
                        reorderable={false}
                        editable={false}
                        width={this.setWidth(40, 3)}
                        cell={(props) => (
                            <IconButtonCell handleClick={(e) => { this.handleDetailsClick(e, props) }} icon="Details" title={this.props.returnLocalizedString("m0281")} {...props} />
                        )}
                    />
                    <Column
                        filterable={false}
                        resizable={false}
                        sortable={false}
                        reorderable={false}
                        cell={(props) => (
                            <BlankCell {...props} />
                        )}
                        editable={false}
                    />
                </GridContainer>

                {this.state.showDialog && (
                    <Dialog
                        className="edit"
                        style={{ top: top }}
                        width={partExceptionDialogWidth}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <EditPartExceptionPage
                            handleCloseModal={this.handleCloseModal}
                            handleRefreshListing={this.handleSearch}
                            orgID={parseInt(this.state.orgID, 10)}
                            orgVendorID={this.props.orgVendorID}
                            partNumber={this.state.selectedPart.partNumber}
                            seasons={this.state.seasons}
                            adjustmentReasons={this.state.adjustmentReasons} />
                    </Dialog>)
                }
                {this.state.showDetailsDialog && (
                    <Dialog
                        className="demand"
                        style={{ top: top }}
                        width={partDemandDialogWidth}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <PartDemandPage
                            handleCloseModal={this.handleCloseDetailsModal}
                            orgID={parseInt(this.state.orgID, 10)}
                            orgVendorID={this.props.orgVendorID}
                            partNumber={this.state.selectedPart.partNumber} />
                    </Dialog>)
                }
                {this.state.showSearchPartDialog && (
                    <Dialog
                        className="search-part"
                        style={{ top: searchPartTop }}
                        width={searchPartDialogWidth}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <SearchPartPage
                            handleCloseModal={this.handleCloseSearchPartModal}
                            orgID={parseInt(this.state.orgID, 10)}
                            orgVendorID={this.props.orgVendorID}
                            suggestedPOID={this.state.suggestedPOID} />
                    </Dialog>)
                }
            </div>
        );
    }
}
export default compose(isPage, withRouter)(VendorSuggestedOrders);
VendorSuggestedOrders.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/VendorSuggestedOrders.js